import React from "react";
import PropTypes from "prop-types";
import renderIf from "../../../utils/renderIf";
import locale from "../../../utils/locale";
import "../Help.css";

const VehicleDetails = ({ year, color, make, model, referenceNumber }) => {
  return (
    <div>
      {renderIf(year || color || make || model || referenceNumber)(
        <div>
          <span className="blue-text">
            <strong>{locale("vehicleDetails")}</strong>
          </span>{" "}
          <strong>
            {year} {make} {model} {color} {referenceNumber}
          </strong>
        </div>
      )}
    </div>
  );
};

VehicleDetails.propTypes = {
  year: PropTypes.any,
  color: PropTypes.string,
  make: PropTypes.string,
  model: PropTypes.string,
  referenceNumber: PropTypes.any
};

export default VehicleDetails;



// WEBPACK FOOTER //
// ./src/components/help/VehicleDetails/index.js